import React from "react";

const AccountingPolicies = () => {
  return (
    <div>
      <h1>SUMMARY OF SIGNIFICANT ACCOUNTING POLICIES</h1>

      <h2>1. Basis of the Preparation of the Financial Statements</h2>
      <p>
        The Financial Statements have been prepared in accordance with Cash
        Basis IPSAS, Financial Reporting under the Cash Basis of Accounting,
        issued by the International Public Sector Accounting Standards Board
        (IPSASB) and Local Authorities Accounting Policies (LAAPs).
      </p>
      <p>
        These financial statements have been prepared in accordance with the
        historical cost convention as the basis of measurement, unless
        specified otherwise.
      </p>
      <p>The accounting policies have been applied consistently throughout the period.</p>

      <h3>1.1 Migration to Accrual Basis Financial Reporting</h3>
      <p>
        Mwansabombwe Town Council is required, under the Local Government Act
        No. 2 of 2019, to produce a Statement of Comprehensive Income and a
        Statement of Financial Position. The production of these statements
        entails adoption and application of Accrual Basis of Accounting in
        financial reporting. However, the Act does not specify which particular
        accrual basis of accounting to use. In applying Cash Basis of
        Accounting, the Council followed guidance listed below:
      </p>

      <p>
        <strong>(a) Cash Basis IPSAS, Financial Reporting under the Cash Basis of Accounting</strong>
        This standard provides that public sector entities adopting Accrual
        Basis for the first time may apply Cash Basis IPSAS provisions as an
        intermediate step to assist them in the transition to Accrual Basis
        IPSASs. In this vein, the Council has produced these financial
        statements under Cash Basis IPSAS as part of its transition to Accrual
        Basis of Accounting.
      </p>

      <p>
        <strong>
          (b) Accounting Pronouncement: 2018/3 – Applicability of International
          Public Sector Accounting Standards (IPSASs)
        </strong>
        This pronouncement issued by the Zambia Institute of Chartered
        Accountants (ZICA) pursuant to the Accountants Act, 2008 requires the
        adoption of Accrual Basis of Accounting by public entities by 31st
        December, 2022. The Council is preparing to adopt Accrual Basis IPSASs
        on 1st January, 2025 according to the Amended Local Authority Accounting
        Policies (LAAPs) No. 2 of 2022.
      </p>

      <p>
        <strong>
          (c) Treasury and Financial Management Circular No 10 of 2019 issued by
          the Secretary to the Treasury pursuant to the Public Financial
          Management Act, No. 1 of 2018
        </strong>
        The Treasury and Financial Management Circular provides as follows:
      </p>

      <ul>
        <li>
          That in order to have a standard financial reporting framework, all
          Local Authorities should adopt the International Public Sector
          Accounting Standards (IPSASs) Cash Basis of Accounting as a first step
          in migration to IPSASs Accrual Basis of Accounting.
        </li>
        <li>
          Local Authorities shall use Part 2 of Cash Basis IPSAS which requires
          extra disclosures called ‘Encouraged Additional Disclosures’ in Cash
          Basis financial statements for the years ending 31st December, 2019 up
          to 2024.
        </li>
        <li>
          All Local Authorities shall adopt and apply Accrual Basis IPSAS of
          Accounting starting 1st January, 2025 by following the guidelines
          provided in IPSAS 33 – “First Time Adoption of Accrual Basis IPSASs”.
        </li>

        <li>
        iv.	That the three (3) year transition period provided under IPSAS 33 should commence on 1st January, 2022 and should end on 31st December, 2024. Thereafter, all Local Authorities shall be required to comply fully with Accrual Basis IPSASs.
        </li>
      </ul>

      <p>
        Based on these guidelines, the Council has not yet commenced production
        of Accrual Basis financial statements required by the Local Government
        Act, 2019. However, the Council has adopted Part 2 Cash Basis IPSAS,
        Financial Reporting under the Cash Basis of Accounting to help it
        transition its financial reporting to Accrual Basis IPSASs.
      </p>

      <h3>1.2 Reporting Entity</h3>
      <p>
        The Financial Statements are prepared for Mwansabombwe Town Council
        (MTC). The financial statements encompass the Council as specified in
        the Constitution of Zambia (Amendment) Act No. 2 of 2016, as read with
        the Local Government Act No.2 of 2019, and the Public Finance Management
        Act No.1 of 2018. It also includes projects and activities of the
        Constituency Development Fund and the Local Government Equalization Fund
        in the district.
      </p>

      <h3>1.3 Authorization Date</h3>
      <p>
        The financial statements were authorized for issue on .................................., by the ordinary/special Council.
      </p>

      <h3>1.4 Revenue</h3>
      <p>Revenue is recognized when cash is received. It is generated from various sources as explained below:</p>

      <p>
        <strong>a. Local Taxes</strong>
      </p>
      <p>
        Article 161 of the Constitution of Zambia (Amendment) Act No. 2 of 2016
        authorizes Mwansabombwe Town Council as a Local Authority to levy,
        impose, recover and retain local taxes. Further, the Local Government
        Act No. 2 of 2019 section 25(1) prescribes, subject to the Constitution
        and the Business Regulatory Act No. 3 of 2014, a system of local taxes
        which Local Authorities can raise by passing By-laws imposing levies on:
      </p>

      <ul>
        <li>
          Leviable persons owning or occupying property or premises situated
          within the area of the District.
        </li>
        <li>
          Leviable persons carrying on a business, trade, or occupation within
          the area of the District.
        </li>
        <li>The purchase or sale of a commodity within the area of the District.</li>
      </ul>

      <p>
        <strong>b. Fees and Charges</strong>
      </p>
      <p>
        Section 27(1) of the Local Government Act No.2 of 2019 empowers Local
        Authorities, subject to the Business Regulatory Act No. 3 of 2014, to
        impose fees or charges payable to the Council:
      </p>

      <ul>
        <li>
          For any license or permit issued under any regulation or By-law made
          under the Act. These may include health permits, fire certificate
          licenses, burial permits, and extension of business hours permits.
        </li>
        <li>
          For any service or facility provided or goods or documents supplied by
          the local authority in pursuance of or in connection with the
          performance of any function of the local authority. These may include
          survey fees, consent fees, building inspection fees, waste collection
          fees, and parking fees.
        </li>
      </ul>


      <h3>1.5 Expenditure</h3>
      <p>Expenditure is recognized when payment is made for expenses incurred. The Council incurs expenditure relating to the discharge of its functions which includes expenses relating to personal emoluments, use of goods and services, social benefits and acquisition of non-financial assets.</p>
    <p>
    Items of a capital nature are expensed at the time of payment and such transactions are depicted in the appropriate class and heading in the financial statements. Since capital expenditure is expensed when incurred, neither depreciation nor amortization is charged on non-current assets.  
    </p>

    <h3>1.6	 Reporting on Gross Basis</h3>

    <p>
    Transactions are reported on gross basis without netting off similar classes of receipts and payments. However, transactions may be reported on net basis when they relate to transactions the Council administers on behalf of other entities recognised in the Financial Statements
    </p>

    <h3>
    1.7	 Cash in hand at the Beginning and the End of the Year  
    </h3>
    <p>Cash at the beginning and end of the year consist of cash on hand, demand deposits and cash equivalents held at such dates. </p>
    <p>
    Cash on hand refers to notes and coins held by the Council at the reporting date and it includes petty cash and cash collections not yet deposited into bank accounts. Demand deposits consist of reconciled balances held in the Council’s bank accounts which it can use on demand. Cash equivalents, on the other hand, refer to short term high liquid investments that can easily be converted to known amounts of cash and are subject to insignificant risk of change in values.  
    </p>

    <p>
    The Council recognises all short term high liquid investments having maturities of three months or less as cash equivalents.
    </p>

    <h3>1.8	Local Government Equalization Fund</h3>
    <p>
    Article 163(2) of the Constitution of Zambia (Amendment) Act No. 2 of 2016 provides that Parliament shall annually appropriate monies to the Local Government Equalization Fund which shall be disbursed by the Ministry responsible for finance to Local Authorities.  Receipts under LGEF supplement revenue generated by the Council. The Council uses at least 20% of the funds received from the equalization fund, in any financial year, to finance capital expenditure and the balance to meet operational expenses.
    </p>

    <h3>
    1.9	Constituency Development Fund 
    </h3>
    <p>
    The Constituency Development Fund (CDF) was established under Article 162(1) of the Constitution of Zambia (Amendment) Act No. 2 of 2016.  
    </p>
    <p>
    The fund was set up to finance micro-community projects for poverty reduction in communities and it is financed by monies appropriated by Parliament. 
    </p>

    <p>
    The administration of CDF is regulated by the Constituency Development Fund Act No. 11 of 2018. The Council maintains separate bank accounts for each constituency. Transfers are made from CDF into constituency bank accounts from which payments are made to finance approved CDF projects.
    </p>
    <h3>
    1.10	Other Grants
    </h3>
    <p>
    These include grants in lieu of rates and support from Cooperating Partners. Grants in lieu of rates are paid by the Government to the Council to cover property rates of Government properties in the district. Support from Cooperating Partners may consist of cash receipts under bilateral and multilateral agreements.
    </p>

    <h3>1.11	Presentation Currency</h3>
    <p>The presentation currency is Zambian Kwacha. </p>

    <h3>1.12	Foreign Currencies</h3>
    <p>
    Transactions in other currencies are converted into Zambian Kwacha using the ruling Bank exchange rates at the time of payment. Balances expressed in foreign currencies at the year-end are translated into Kwacha at the ruling rate then. The resulting difference from the conversion and translation are charged to the Statement of Cash Receipts and Payments. 
    </p>

    <h3>
    1.13	Borrowings  
    </h3>
    <p>Borrowings comprise actual cash inflows received from financial institutions, bilateral and multilateral institutions.  </p>

    <h3>1.14	Budgets and Actual Amounts</h3>
    <p>A final budget includes all adjustments (supplementary and re-allocations) made to the original approved budget during the year. Supplementary budgets consist of additional provisions beyond what was originally approved while re-allocations are approved budget variations.</p>
    <p>
    The approved budget is developed on the same accounting and classification basis, and for the same period as for the financial statements.  All material differences between final budgets and actual amounts are explained in the notes to the annual financial statements. Budget differences of 20% and above are considered material. 
    </p>
    
    </div>
  );
};

export default AccountingPolicies;
